// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/payment/v1/sales_finalization.proto (package stailer_service_specification.payment.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/payment/v1/sales_finalization.proto.
 */
const file_stailer_service_specification_payment_v1_sales_finalization = /*@__PURE__*/
  fileDesc("CkFzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9wYXltZW50L3YxL3NhbGVzX2ZpbmFsaXphdGlvbi5wcm90bxIoc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ucGF5bWVudC52MSLYAQoRU2FsZXNGaW5hbGl6YXRpb24SwgEKFWNhcHR1cmVfbG9va2JhY2tfZGF5cxgBIAEoBUKiAZKCGXvjgq3jg6Pjg5fjg4Hjg6Plrp/ooYzmmYLjgavjgIHlj5fjgZHlj5bjgorlrozkuobmuIjjgb/ms6jmlofjgpLkvZXml6XliY3jgb7jgafpgaHjgaPjgablr77osaHjgajjgZnjgovjgYvjgpLmjIflrprjgZfjgb7jgZmqghkb44Kt44Oj44OX44OB44Oj6YGh44KK5pel5pWwyIIZAWIGcHJvdG8z", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.payment.v1.SalesFinalization.
 * Use `create(SalesFinalizationSchema)` to create a new message.
 */
const SalesFinalizationSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_payment_v1_sales_finalization, 0);


exports.file_stailer_service_specification_payment_v1_sales_finalization = file_stailer_service_specification_payment_v1_sales_finalization;
exports.SalesFinalizationSchema = SalesFinalizationSchema;
